export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyA4cFUBlp67ZOorSVXGg9AgQ5dcaUt9kR4'
export const FIREBASE_AUTH_DOMAIN =
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'hr-novarto-nordic-staging.firebaseapp.com'
export const OAUTH_CLIENT_ID =
  process.env.REACT_APP_OAUTH_CLIENT_ID || '820969547738-aqlkiimd0vj0ej18qbpo973lniok9adh.apps.googleusercontent.com'
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'
